// extracted by mini-css-extract-plugin
export default {"ghost":"ghost-ke8_"};